import * as React from 'react';

import { Color, CustomPicker, InjectedColorProps } from 'react-color';
import { Hue, Saturation } from 'react-color/lib/components/common';
import styled from 'styled-components';

import { CustomColorPickerFields } from './custom-color-picker-fields';
import { CustomColorPickerPointer, CustomColorPickerPointerCircle } from './custom-color-picker-pointer';

export interface SwatchProps {
    color: Color;
}

export interface CustomColorPickerProps extends InjectedColorProps {
    color?: Color;
    dataId: string;
    onChange: (color: any) => void;
}

const StyledSwatch = styled.div<InjectedColorProps>`
    height: 60px;
    width: 80px;
    background: ${(props) => props.color};
`;

const StyledHue = styled.div`
    position: relative;
    width: 19px;
    margin-left: 5px;
    border: 1px solid #b3b3b3;
    margin-bottom: 2px solid #f0f0f0;
`;

const StyledSaturation = styled.div`
    width: 250px;
    position: relative;
    border: 1px solid #b3b3b3;
    border-bottom: 2px solid #f0f0f0;
    overflow: hidden;
`;

const Controls = styled.div`
    flex: 1;
    margin-left: 10px;
`;

const StyledCustomColorPicker = styled.div`
    padding: 16px;
    display: flex;
`;

const CustomColorPicker = React.forwardRef<HTMLDivElement, CustomColorPickerProps>(
    ({ dataId, color, onChange, ...props }, ref) => {
        return (
            <StyledCustomColorPicker ref={ref} {...props} data-test-id={dataId}>
                <StyledSaturation>
                    {/* @ts-ignore */}
                    <Saturation {...props} color={color} pointer={CustomColorPickerPointerCircle} onChange={onChange} />
                </StyledSaturation>
                <StyledHue>
                    <Hue
                        {...props}
                        direction="vertical"
                        color={color}
                        pointer={CustomColorPickerPointer}
                        onChange={onChange}
                    />
                </StyledHue>
                <Controls>
                    <CustomColorPickerFields {...props} onChange={onChange} />
                    <StyledSwatch color={props.hex} data-test-id={`${dataId}__swatch-div`} />
                </Controls>
            </StyledCustomColorPicker>
        );
    },
);

CustomColorPicker.displayName = 'CustomColorPicker';

export const SpotlightPicker = CustomPicker(CustomColorPicker);
